import { render, staticRenderFns } from "./CoockSliderStudents.vue?vue&type=template&id=08c8dde8&scoped=true&"
import script from "./CoockSliderStudents.vue?vue&type=script&lang=js&"
export * from "./CoockSliderStudents.vue?vue&type=script&lang=js&"
import style0 from "./CoockSliderStudents.vue?vue&type=style&index=0&id=08c8dde8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c8dde8",
  null
  
)

export default component.exports